import { useState } from 'react';
import type { Task } from '@unitly/contracts';
import { useStates, useUpdateTask } from '../../api/queries.ts';
import { useOrgCtx } from '../../app/org-context.tsx';
import { TaskMeta } from './TaskRow.tsx';

/** Kanban by workflow state. Drag & drop on desktop; on phones columns snap horizontally and cards open on tap. */
export function TaskBoard({ tasks, showWorkspace = true }: { tasks: Task[]; showWorkspace?: boolean }) {
  const { orgId, openTask } = useOrgCtx();
  const states = useStates(orgId);
  const update = useUpdateTask(orgId);
  const [over, setOver] = useState<string | null>(null);

  if (!states.data) return null;
  return (
    <div className="board" role="list" aria-label="Board per stato">
      {states.data.map((s) => {
        const items = tasks.filter((t) => t.state.id === s.id);
        return (
          <div
            key={s.id}
            role="listitem"
            className={`board-col${over === s.id ? ' over' : ''}`}
            onDragOver={(e) => {
              e.preventDefault();
              setOver(s.id);
            }}
            onDragLeave={() => setOver((o) => (o === s.id ? null : o))}
            onDrop={(e) => {
              e.preventDefault();
              setOver(null);
              const id = e.dataTransfer.getData('text/task-id');
              const task = tasks.find((t) => t.id === id);
              if (task && task.state.id !== s.id && task.permissions.edit) update.mutate({ id, patch: { stateId: s.id } });
            }}
          >
            <div className="board-col-head">
              <span className="pill" data-cat={s.category}>{s.name}</span>
              <span className="n">{items.length}</span>
            </div>
            {items.map((t) => (
              <button
                key={t.id}
                type="button"
                className="board-card"
                draggable={t.permissions.edit}
                onDragStart={(e) => e.dataTransfer.setData('text/task-id', t.id)}
                onClick={() => openTask(t.id)}
              >
                <span className="task-title">{t.title}</span>
                <TaskMeta task={t} showWorkspace={showWorkspace} />
              </button>
            ))}
          </div>
        );
      })}
    </div>
  );
}
